import { Leaf, Cpu, Users, Factory } from "lucide-react";

const PILLARS = [
  {
    Icon: Leaf,
    title: "Green by default",
    body: "Every vehicle in our lineup runs on lithium-ion power. No fumes, no noise, no compromise.",
  },
  {
    Icon: Cpu,
    title: "Indian engineering",
    body: "Designed, assembled and serviced in India — tuned for Indian roads and Indian weather.",
  },
  {
    Icon: Users,
    title: "For every rider",
    body: "Low-speed and license-free means everyone in the family can ride — students, parents, seniors.",
  },
  {
    Icon: Factory,
    title: "Built to last",
    body: "Quality components, accessible spares, and a service network growing with our roads.",
  },
];

export default function About() {
  return (
    <div data-testid="page-about" className="pb-12">
      <section className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-16">
          <p
            data-testid="about-eyebrow"
            className="text-[11px] uppercase tracking-[0.22em] text-emerald-700 font-semibold"
          >
            About us
          </p>
          <h1
            data-testid="about-title"
            className="mt-3 font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tight font-light text-slate-950 max-w-4xl leading-[1.05]"
          >
            A small Indian business with a big, quiet idea.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-slate-600 leading-relaxed font-light">
            ANANDSAHNI GREEN MOBILITY was started with a simple belief — that
            most of India&apos;s daily distances are short, and short distances should
            be electric. Today we build low-speed two-wheelers, each one
            engineered to make the everyday commute cleaner, cheaper and far less
            complicated.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl overflow-hidden bg-slate-100 flex items-center justify-center">
          <img
            src="/media/about.jpg"
            alt="Our showroom & warehouse"
            className="w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-24" data-testid="about-pillars">
        <p className="text-[11px] uppercase tracking-[0.22em] text-emerald-700 font-semibold">
          What we believe
        </p>
        <h2 className="mt-3 font-heading text-3xl sm:text-4xl tracking-tight text-slate-950">
          Four ideas that drive every vehicle we make.
        </h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PILLARS.map(({ Icon, title, body }) => (
            <div
              key={title}
              data-testid={`pillar-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-3xl border border-slate-200 bg-white p-8"
            >
              <Icon className="h-5 w-5 text-emerald-600" />
              <h3 className="mt-6 font-heading text-2xl text-slate-950">{title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-24" data-testid="about-stats">
        <div className="rounded-3xl bg-slate-950 text-white p-10 sm:p-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { k: "6", v: "Models in the lineup" },
              { k: "25", v: "km/h, license-free" },
              { k: "170", v: "km maximum range" },
              { k: "0", v: "Tailpipe emissions" },
            ].map((s) => (
              <div key={s.v}>
                <p className="font-heading text-5xl text-white">{s.k}</p>
                <p className="mt-2 text-xs uppercase tracking-[0.18em] text-slate-400">{s.v}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
